import { useState } from "react";

/**
 * TrackHeroImage — a painterly editorial hero image at the top of a track
 * reading. Each track has two variants on disk: men/women. We use the user's
 * program prop to pick the right one and fall back gracefully (returns null)
 * if the image is missing (e.g., not yet generated).
 *
 * Image files are expected at /images/tracks/{program}/{slug}.png (served
 * from frontend/public/).
 */
export default function TrackHeroImage({ slug, program, title }) {
  const [failed, setFailed] = useState(false);

  if (!slug || !program || failed) return null;
  const src = `/images/tracks/${program}/${slug}.png`;

  return (
    <div
      className="relative w-full aspect-[3/2] md:aspect-[3/1] overflow-hidden rounded-md mb-6 border border-[#C9A961]/15 bg-[#1A1816]"
      data-testid={`track-hero-${program}-${slug}`}
    >
      <img
        src={src}
        alt={`Editorial illustration for ${title || slug}`}
        loading="lazy"
        onError={() => setFailed(true)}
        className="w-full h-full object-cover"
      />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#0A0908]/85 via-transparent to-transparent" />
    </div>
  );
}
